/**
 * TeamPresenter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { Presenter } from '../../presenters/presenter';

export class TeamGroupPresenter extends Presenter {
    get name() {
        return this.description;
    }

    get description() {
        return this.data.description;
    }

    get is_sage_enabled() {
        return this.data.is_sage_enabled;
    }
}
